import { setCookie } from './helpers/cookies'

function initCookies()
{
  if(!$('.cookies-container').length) return false

  const cookieCheckboxes = $('.cookies-checkboxes')
  const cookieSave = $('.cookies-save')
  const $body = $('body')

  $body.on('click', '.show-cookie-checkboxes', function (e) {
    e.preventDefault()

    $(this).hide()
    cookieCheckboxes.removeClass('d-none')
    cookieSave.removeClass('d-none')
  })

  $body.on('click', '.cookies-save', function (e) {
    e.preventDefault()

    saveCookies()
  })

  $body.on('click', '.cookies-save-all', function (e) {
    e.preventDefault()
    $('.cookies-checkboxes input[type="checkbox"]').each(function () {
      $(this).attr('checked', true)
    })
    saveCookies()
  })


  function saveCookies() {
    $('.cookies-checkboxes input[type="checkbox"]:checked').each(function () {
      setCookie($(this).attr('id'), 1, 720)
    })

    window.location.reload()
  }

}

initCookies()
